import actions from './cloudCannon/actions'
import getters from './cloudCannon/getters'
import mutations from './cloudCannon/mutations'

const state = {
  cloudCannonContent: {},
  cloudCannonContentLoading: false,

  // I was dumb and didn't consider that we might need to make multiple requests for content
  // on any given page.  So for now, this is a monkey patch.  Refactor later...
  cloudCannonFooterContent: {
    privacy_policy: '',
  },
  cloudCannonFooterContentLoading: false
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
